import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SaveCallScriptFormResult } from "../types/SaveCallScriptFormResult";
import { SavePlumbingScheduleFormFormParams } from "../types/SavePlumbingScheduleFormFormParams";

export const useSavePlumbingScheduleScriptForm = (
	params: SavePlumbingScheduleFormFormParams,
	onSuccess: (result: SaveCallScriptFormResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	method = 'save-plumbingScheduleForm';
	requestParams = {
		...params.formObject
	};
	
	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/" + method, requestParams) as SaveCallScriptFormResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)	
				onSuccess(result);
			else
				onError(`Error when saving the pdf file"}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}